import { Component, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ChunkErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // Verifica se é erro de carregamento de chunk
    if (
      error.message.includes("Failed to fetch dynamically imported module") ||
      error.message.includes("error loading dynamically imported module") ||
      error.message.includes("Loading chunk")
    ) {
      return { hasError: true };
    }
    throw error;
  }

  componentDidCatch(error: Error) {
    console.error("ChunkLoadError detectado:", error);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-6 p-4">
          <div className="text-center max-w-md">
            <h2 className="text-xl font-semibold text-foreground mb-2">
              Update Available
            </h2>
            <p className="text-muted-foreground mb-6">
              A new version of the app is available. Please reload to continue.
            </p>
            <button
              onClick={this.handleReload}
              className="px-6 py-3 bg-gold text-black font-medium rounded-lg hover:bg-gold/90 transition-colors"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
